import { useStyletron } from 'baseui'; // eslint-disable-next-line baseui/no-deep-imports
import { mergeOverride, toObjectOverride } from 'baseui/helpers/overrides';
import { Icon, IconProps } from 'baseui/icon';
import { h } from 'preact';
import { forwardRef } from 'preact/compat';

export default forwardRef<SVGSVGElement, IconProps>((props: IconProps, ref) => {
    const [, theme] = useStyletron();
    const { title = 'Route', size, color, overrides = {},...restProps } = props;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    const SvgOverride = mergeOverride( // @ts-ignore
        { component: theme.icons?.Route ? theme.icons.Route : null },
        overrides?.Svg ? toObjectOverride(overrides.Svg) : {},
    );
    return (
        <Icon viewBox="0 96 960 960"
              ref={ref}
              title={title}
              size={size}
              color={color}
              overrides={{ Svg: SvgOverride }}
              {...restProps}>
            <path d="M360 936q-66 0-113-47t-47-113V449q-35-13-57.5-43.5T120 336q0-50 35-85t85-35q50 0 85 35t35 85q0 39-22.5 69.5T280 449v327q0 33 23.5 56.5T360 856q33 0 56.5-23.5T440 776V376q0-66 47-113t113-47q66 0 113 47t47 113v327q35 13 57.5 43.5T840 816q0 50-35 85t-85 35q-50 0-85-35t-35-85q0-39 22.5-70t57.5-43V376q0-33-23.5-56.5T600 296q-33 0-56.5 23.5T520 376v400q0 66-47 113t-113 47ZM240 376q17 0 28.5-11.5T280 336q0-17-11.5-28.5T240 296q-17 0-28.5 11.5T200 336q0 17 11.5 28.5T240 376Zm480 480q17 0 28.5-11.5T760 816q0-17-11.5-28.5T720 776q-17 0-28.5 11.5T680 816q0 17 11.5 28.5T720 856ZM240 336Zm480 480Z" />
        </Icon>
    );
});
